import { render, staticRenderFns } from "./EventoProfile.vue?vue&type=template&id=38027db5"
import script from "./EventoProfile.vue?vue&type=script&lang=js"
export * from "./EventoProfile.vue?vue&type=script&lang=js"
import style0 from "./EventoProfile.vue?vue&type=style&index=0&id=38027db5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports